<!-- 直播间管理-->
<template>
  <div class="room-wrap">
    <!-- 左侧用户列表部分 -->
    <div class="audience-list">
      <div class="tab-list">
        <div class="tab-item" v-for="item in audienceList" :key="item.key" :class="currentAudience === item.key ? 'active' : ''" @click="handleClickAudience(item)">{{item.title}}</div>
      </div>
      <div class="user-box">
        <div class="user-content" v-for="(item, index) in userList" :key="index">
          <img :src="item.avator" alt="" class="user-avator">
          <div style="cursor: pointer;" @click.stop="handleShowCard(item, index)">
            <span>{{item.name}}</span>
            <div v-if="currentAudience !== 0">
              <div style="color: 8e929f;font-size: 12px;">{{item.banTime}}解禁</div>
              <div style="color: #3a91f3;font-size: 12px;" @click.stop="removeBan(item, index)">立即解禁</div>
            </div>
          </div>
          <div v-show="item.isShowAction">
            <div v-if="isShowSelect" class="block-panel">
              <div class="block-panel-content" v-for="(item1, index1) in actionList" :key="index1" @click.stop="handleAction(index1)">
                <img :src="item1.url" alt="" class="action-icon">
                <p>{{item1.text}}</p>
              </div>
            </div>
            <div v-else class="block-time">
              <p>{{banText}}</p>
              <a-select default-value="1" size="small" style="width: 100px" @change="handleChangeSelect" class="block-time-select">
                <a-select-option :value="item2.value" v-for="item2 in banTime" :key="item2.value">{{item2.label}}</a-select-option>
              </a-select>分钟
              <div class="block-time-opt">
                <button class="block-time-confirm" @click="handleConfigBan(item)">确认</button>
                <button class="block-time-cancel" @click="handleClickBody()">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中间视频部分 -->
    <div class="rong-video-wrap">
      <div class="anchor-box">
        <div class="anchor-info-l">
          <img :src="avator" alt="" class="avator">
          <div class="info-detail">
            <div style="color: #000;">{{userName}}</div>
            <div class="list">
              <div v-for="item in detailList" :key="item.key" class="item">
                <img :src="item.icon" alt="" class="icon">
                {{item.title}} {{item.value}}
              </div>
            </div>
          </div>
        </div>
        <div class="anchor-icon-r">
          <img :src="item.url" alt="" class="icon-r" v-for="item in iconList" :key="item.key">
        </div>
      </div>
      <div class="wrap-video">
        <img src="../../../assets/images/liveIcon/icon_fullscreen.png" alt="" class="video-btn-icon" @click="Screen">
        <div class="view-list-wrap">
          <div class="upload-video" v-if="uploadVideoUrl.length">
            <video :src="uploadVideoUrl" class="load-video" autoplay loop></video>
          </div>
          <div class="view-list"></div>
        </div>
        <div class="gift-box-wrap" v-if="isShowGift">
          <img :src="giftInfo.avator" class="live-user-avator"/>
          <div class="live-user-detail">
            <div class="live-user-name">{{giftInfo.name}}</div>
            <div class="live-gift-icon">
              <img :src="giftInfo.giftIcon" alt="" class="gift-icon">
              <span>{{giftInfo.giftName}} x{{giftInfo.number}}</span>
            </div>
          </div>
        </div>
        <div class="rong-video-box"></div>
        <div class="btn-wrap">
          <button class="btn-close" @click="closeRoom(this)">关闭直播</button>
          <div>若直播不健康，可直接将其关闭</div>
        </div>
      </div>
    </div>

    <!-- 右侧聊天列表及礼物列表部分 -->
    <div class="chat-list">
      <div class="tab-list">
        <div class="tab-item" v-for="item in showList" :key="item.key" :class="curentShow === item.key ? 'active' : ''" @click="handleClickShow(item)">
          <a-icon :type="item.type" theme="filled"/>
          {{item.title}}
        </div>
      </div>
      <div class="chat-box">
        <div v-if="curentShow === 0">
          <div class="message-list">
            <div class="message-box" v-for="(item, index) in inoutList" :key="index">
              <div class="message-item">
                <span class="message-user-name">
                  {{item.type === 2 ? item.name + ':' : item.name}}
                  <span class="message-user-content" v-if="item.type === 1">{{item.action}}</span>
                  <span class="message-user-content" v-if="item.type === 2">{{item.desc}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="message-input">
            <textarea cols="30" rows="10" maxlength="100" placeholder="输入文字内容" class="textarea" v-model="userInput"></textarea>
            <div class="send-wrap">
              <span class="emoji-btn" @click="isShowEmoji = true"></span>
              <div class="emoji-panel" v-if="isShowEmoji">
                <span class="emoji-content" v-for="item in emojiList" :key="item"
                  :title="item.symbol"
                  v-html="getNodeHtml(item.node)"
                  @click="setEmoji(item.emoji)">
                </span>
              </div>
              <button :disabled="btnDisabled" class="input-send" :class="userInput.length ? 'isBtn' : ''" @click="sendMsgToList">发 送</button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="gift-content" v-for="(item, index) in inoutList" :key="index">
            <span class="gift-rank" v-if="index < 3">{{index + 1}}</span>
            <img :src="item.avator" alt="" class="gift-portrait" :style="index > 2 ? 'margin-left:29px;' : ''">
            <span class="gift-user-name">{{item.name}}</span>
            <span class="gift-send">发送礼物
              <a-popover placement="bottom">
                <template slot="content">
                  <p>{{item.name}} 发送礼物信息:</p>
                  <div v-for="(item1, index1) in item.giftList" :key="index1">
                    {{item1.giftName}} {{item1.number}} 个
                  </div>
                </template>
              <span class="gift-count">{{item.number}}</span>
              </a-popover>
              <!-- <span class="gift-count">{{9}}</span> -->
              个</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import video from './video.js';
export default video;
</script>

<style lang="scss">
@import 'video';
</style>
